import { useTranslation } from "../i18n/LanguageContext";
import DocumentMeta from "react-document-meta";
import { buildPageMeta } from "../seo";

function ProjectsPage() {
    const { t } = useTranslation();
    const meta = buildPageMeta({
        title: `${t("projects.title")} | Maurizio Brioschi`,
        description: "Pagina progetti e contenuti in evoluzione del sito Maurizio Brioschi.",
        keywords: "progetti, portfolio, sviluppo software",
        path: "/projects"
    });
    return(
        <>
            <DocumentMeta {...meta} />
            <h1>{t("projects.title")}</h1>
        </>

    );
}

export default ProjectsPage;
